import React, { useState } from 'react';
import { FaClipboardList, FaPen, FaQuoteLeft } from 'react-icons/fa';

const STATUS_STYLES = {
  saved: 'bg-green-50 text-green-700 border-green-200',
  initiated: 'bg-amber-50 text-amber-700 border-amber-200'
};

const LONG_NOTE_LENGTH = 220;

const OrderNoteCard = ({ note, status, onEdit, className = '' }) => {
  const [expanded, setExpanded] = useState(false);

  if (!note || !note.trim()) return null;

  const statusKey = String(status || '').toLowerCase();
  const isLong = note.length > LONG_NOTE_LENGTH || note.split('\n').length > 4;

  return (
    <div className={`border border-gray-200 rounded-lg p-4 bg-gray-50 ${className}`}>
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2 text-sm font-semibold text-gray-900">
          <FaClipboardList className="text-blue-600 w-4 h-4" />
          Order Note
          {STATUS_STYLES[statusKey] && (
            <span className={`px-2 py-0.5 text-xs font-medium rounded-full border capitalize ${STATUS_STYLES[statusKey]}`}>
              {statusKey}
            </span>
          )}
        </div>
        {onEdit && (
          <button
            type="button"
            onClick={onEdit}
            className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-blue-700 bg-blue-50 hover:bg-blue-100 border border-blue-200 rounded-md transition-colors"
          >
            <FaPen className="w-2.5 h-2.5" />
            Edit note
          </button>
        )}
      </div>

      <div className="relative flex gap-3 p-3 bg-white border border-gray-200 border-l-4 border-l-blue-500 rounded-md">
        <FaQuoteLeft className="shrink-0 mt-0.5 w-3.5 h-3.5 text-blue-200" />
        <div className="flex-1 min-w-0">
          <p
            className={`text-sm text-gray-700 leading-relaxed whitespace-pre-wrap break-words ${
              isLong && !expanded ? 'line-clamp-4' : ''
            }`}
          >
            {note}
          </p>
          {isLong && (
            <button
              type="button"
              onClick={() => setExpanded(prev => !prev)}
              className="mt-1.5 text-xs font-medium text-blue-600 hover:text-blue-700 transition-colors"
            >
              {expanded ? 'Show less' : 'Show more'}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default OrderNoteCard;
